import React from "react";
import {
  useI18N,
  VenueDetailsBySlugResponse,
  useModalHeight,
} from "common/hooks";

import { XIcon } from "lucide-react";
import { useDarkMode } from "@/hooks/useDarkMode";
import { cn } from "@/lib/utils";
import { StandardButton } from "@/components/common/StandardButton";

function AreaDetailsNotes(props: {
  venueDetailsResponse: VenueDetailsBySlugResponse;
  onClose: () => void;
  mode: string;
}) {
  const i18n = useI18N();
  const { modalStyle, modalClassName } = useModalHeight();
  const isDark = useDarkMode();

  return (
    <>
      <section style={modalStyle} className={cn(modalClassName)} role="none">
        <header className="py-4 min-h-14 flex items-center justify-between text-center px-6 border-b border-border-token-brand-minimal vsticky top-0">
          <StandardButton
            onClick={props.onClose}
            variant="closeModal"
            tabIndex={0}
            aria-label="Close modal"
            icon={<XIcon color={isDark ? "#A39FE8" : "#352FC3"} />}
            className="flex-shrink-0"
          />
          <h1 className="title-s-semibold text-center text-fg-neutral-strong flex-1 px-4">
            {i18n.get("priorityLevels")}
          </h1>
          <div className="flex-shrink-0 w-10"></div>{" "}
          {/* Spacer to balance the layout */}
        </header>

        <div
          aria-label="Modal Content"
          className="flex-grow overflow-y-auto py-3 px-3"
          role="none"
        >
          <div className="self-stretch px-1 pt-2 flex-col justify-start items-center gap-2 flex">
            <div className="self-stretch rounded-lg justify-start items-center gap-8 inline-flex">
              <div className="mb-2">
                <div className="flex flex-col mt-1">
                  <div className="flex items-center gap-2">
                    <div className="flex-1">
                      <div className="flex flex-col gap-4">
                        {(props.mode === "mappernote"
                          ? props.venueDetailsResponse.details
                              .businessNotesActions
                          : props.venueDetailsResponse.details
                              .businessNotesActionsVenueNotes
                        )
                          ?.filter((option) => option.description)
                          ?.map((option) => {
                            const sections = option.description.split("##");
                            const titleParts = sections[0].split(":");
                            const mainTitle = titleParts[0].trim();
                            const subtitle = titleParts[1]?.trim();
                            const description = sections[1];
                            return (
                              <div
                                key={option.id}
                                className="border-b border-border-token-neutral-minimal px-5 py-4"
                              >
                                <p className="title-s-semibold text-fg-neutral-strong">
                                  {mainTitle}
                                </p>
                                {subtitle && (
                                  <p className="label-m-medium text-fg-neutral-subtle mt-1 mb-2">
                                    {subtitle}
                                  </p>
                                )}
                                {description && (
                                  <div className="flex gap-2">
                                    <span className="text-fg-neutral-subtle">•</span>
                                    <p className="label-m-medium text-fg-neutral-subtle">
                                      {description}
                                    </p>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="md:hidden border w-full border-border-token-brand-minimal mt-1 h-[1px]"></div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AreaDetailsNotes;
